/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-10-07T08:44:05.540Z
 * 소스 파일: src/data/dto/super-admin/operation-log-reponse-dto
 */

import type { OperationLogResponseDto } from "@/data/dto/super-admin/operation-log-reponse-dto";

/**
 * OperationLogResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isOperationLogResponseDto(input: unknown): input is OperationLogResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.totalCount === "number" && !isNaN(obj.totalCount) &&
    typeof obj.totalPage === "number" && !isNaN(obj.totalPage) &&
    Array.isArray(obj.list) && obj.list.every((item) => typeof item === "object" && item !== null && !Array.isArray(item) &&
typeof (item as any).createdAt === "string" &&
typeof (item as any).type === "string" &&
typeof (item as any).event === "string" &&
  ((item as any).subUser === undefined || true) &&
  ((item as any).targetUser === undefined || true) &&
  ((item as any).detail === undefined || true))
  );
}

/**
 * OperationLogResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validateOperationLogResponseDto(input: unknown): IValidation<OperationLogResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // totalCount (required)
      if (objObj.totalCount === undefined) {
        errors.push({ path: "totalCount", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.totalCount === "number" && !isNaN(objObj.totalCount))) {
          errors.push({ path: "totalCount", expected: "number", value: objObj.totalCount });
        }
      }
      // totalPage (required)
      if (objObj.totalPage === undefined) {
        errors.push({ path: "totalPage", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.totalPage === "number" && !isNaN(objObj.totalPage))) {
          errors.push({ path: "totalPage", expected: "number", value: objObj.totalPage });
        }
      }
      // list (required)
      if (objObj.list === undefined) {
        errors.push({ path: "list", expected: "array", value: undefined });
      } else {
        if (!Array.isArray(objObj.list)) {
          errors.push({ path: "list", expected: "array", value: objObj.list });
        } else {
          objObj.list.forEach((item, idx) => {
              if (typeof item !== "object" || item === null || Array.isArray(item)) {
          errors.push({ path: "list[idx]", expected: "object", value: item });
        } else {
          const itemObj = item as Record<string, unknown>;
          // createdAt (required)
          if (itemObj.createdAt === undefined) {
            errors.push({ path: "list[idx].createdAt", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.createdAt !== "string") {
              errors.push({ path: "list[idx].createdAt", expected: "string", value: itemObj.createdAt });
            }
          }
          // type (required)
          if (itemObj.type === undefined) {
            errors.push({ path: "list[idx].type", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.type !== "string") {
              errors.push({ path: "list[idx].type", expected: "string", value: itemObj.type });
            }
          }
          // event (required)
          if (itemObj.event === undefined) {
            errors.push({ path: "list[idx].event", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.event !== "string") {
              errors.push({ path: "list[idx].event", expected: "string", value: itemObj.event });
            }
          }
          // subUser (optional)
          if (itemObj.subUser !== undefined) {
          
          }
          // targetUser (optional)
          if (itemObj.targetUser !== undefined) {
          
          }
          // detail (optional)
          if (itemObj.detail !== undefined) {
          
          }
        }
          });
        }
      }
    }
  
  if (errors.length === 0 && isOperationLogResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "OperationLogResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * OperationLogResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertOperationLogResponseDto(input: unknown): OperationLogResponseDto {
  const validation = validateOperationLogResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertOperationLogResponseDto] :: 검증 실패: OperationLogResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
